module.exports = __webpack_public_path__ + "static/img/产品中心-Coalclaw私有化智能助手-case.0cc6fd6e.png";